import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdb9e19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "task-crop-image-modal__content"
}
const _hoisted_2 = { class: "task-crop-image-modal__wrapper-crop" }
const _hoisted_3 = {
  key: 1,
  class: "task-crop-image-modal__spinner-wraper"
}

import {
  TirPmModal,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmFileUploader,
  TirPmButtonSizeEnum,
  TirPmInput,
  TirCheckbox,
  TirPmSpinner,
} from "tir-components";
import { ArrowUpTrayIcon } from "tir-style-system/icons/outline";
import { TirPmCropper } from "tir-pm-cropper";
import { computed, PropType, ref } from "vue";
import { TaskCropImageModel } from "./models";
import {
  getBase64FromFile,
  getFileExtension,
  isValidBase64,
  removeFileExtension,
} from "../../utils";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-crop-image-modal',
  props: {
  /**Существующие имена файлов */
  existFileNames: { type: Array as PropType<string[]> },
  /**Загрузка */
  isLoading: { type: Boolean, default: false },
},
  emits: ["onClose", "onConfirm"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Режим редактирования */
const isEditMode = ref(false);
/**Заголовок */
const title = computed(() => (isEditMode.value ? "Редактирование фото" : "Загрузка фото"));
/**Текст для кнопки подтверждения */
const confirmButtonText = computed(() => (isEditMode.value ? "Применить изменения" : "Сохранить"));
/**Данные формы */
const formData = ref<TaskCropImageModel>();
/**Исходное изображение */
const imageSrc = ref("");
/**Изображение в кроппе */
const croppedImage = ref("");
/**Загрузка модального окна */
const isLoadingModal = ref(false);

/**Название  */
const fileName = computed({
  get() {
    return removeFileExtension(formData.value.FileName);
  },
  set(value) {
    const fileExt = getFileExtension(formData.value.FileName);
    formData.value.FileName = `${value}.${fileExt}`;
  },
});
/**Ошибка с повторяющимся именем файла */
const fileNameError = computed(() => {
  return !fileName.value || props.existFileNames.includes(formData.value.FileName);
});

/**При загрузке файлов */
const onUploadFiles = async (files: Array<File>) => {
  if (!files.length) return;
  const [file] = files;
  const base64 = await getBase64FromFile(file);
  if (!base64) return;

  imageSrc.value = base64;
  croppedImage.value = base64;
  formData.value = new TaskCropImageModel({
    Base64OrUrl: base64,
    FileName: file.name,
    CompressFile: formData.value.CompressFile,
  });
};
/**При кропе изображения */
const onCroppedImage = (image: string, setDefault: boolean = false) => {
  if (setDefault || !isValidBase64(image)) return;
  croppedImage.value = image;
};
/**Открыто ли модальное окно */
const isOpened = computed(() => !!formData.value);
/**Установить изображение */
const setImageSrc = async (base64OrUrl: string) => {
  // Проверяем, является ли строка URL
  if (base64OrUrl.includes("http")) {
    try {
      const response = await fetch(base64OrUrl);
      if (response.ok) {
        const blob = await response.blob();
        const reader = new FileReader();

        // Конвертируем Blob в base64
        reader.onloadend = () => {
          const base64data = reader.result as string;
          imageSrc.value = base64data;
          croppedImage.value = base64data;
        };
        reader.readAsDataURL(blob);
      }
    } catch (e) {
      console.error(e);
    }
  } else {
    if (base64OrUrl.startsWith("data:image")) {
      imageSrc.value = base64OrUrl;
      croppedImage.value = base64OrUrl;
    }
  }
};
/**Открыть модальное окно */
const open = async (data: TaskCropImageModel, _isEditMode: boolean) => {
  isEditMode.value = _isEditMode;
  isLoadingModal.value = true;
  formData.value = data;
  await setImageSrc(data.Base64OrUrl);
  isLoadingModal.value = false;
};
/**Закрыть модальное окно */
const close = () => {
  croppedImage.value = "";
  formData.value = undefined;
};
/**При закрытии модального окна */
const onClose = () => {
  close();
  emit("onClose");
};
/**Кликн на кнопку подтверждения */
const onClickConfirm = () => {
  emit(
    "onConfirm",
    new TaskCropImageModel({
      Base64OrUrl: croppedImage.value,
      FileName: formData.value.FileName,
      CompressFile: formData.value.CompressFile,
    }),
  );
};

__expose({
  open,
  close,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    classes: "task-crop-image-modal",
    "is-visible": isOpened.value,
    title: title.value,
    "is-with-back": false,
    onClose: onClose
  }, {
    content: _withCtx(() => [
      (formData.value && imageSrc.value && !isLoadingModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(TirPmInput), {
              modelValue: fileName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileName).value = $event)),
              label: "Название файла",
              "is-with-hint": fileNameError.value,
              "is-with-error": fileNameError.value
            }, {
              hintMessage: _withCtx(() => [
                _createTextVNode(" Недопустимое имя файла ")
              ]),
              _: 1
            }, 8, ["modelValue", "is-with-hint", "is-with-error"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TirPmCropper), {
                class: "task-crop-image-modal__crop",
                modelValue: croppedImage.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((croppedImage).value = $event)),
                src: imageSrc.value,
                "min-height": 390,
                "is-no-aspect": "",
                aspect: 0,
                "is-max-default-size": "",
                "show-center-points": true,
                onOnCroppedPhoto: onCroppedImage
              }, null, 8, ["modelValue", "src"])
            ]),
            (!isEditMode.value)
              ? (_openBlock(), _createBlock(_unref(TirPmFileUploader), {
                  key: 0,
                  class: "task-crop-image-modal__replace-image-button",
                  "allowed-extensions": ['gif', 'jpg', 'jpeg', 'png', 'svg', 'webp'],
                  onUploadFiles: onUploadFiles
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      size: _unref(TirPmButtonSizeEnum).Small
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(ArrowUpTrayIcon))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Загрузить другое фото ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!isEditMode.value)
              ? (_openBlock(), _createBlock(_unref(TirCheckbox), {
                  key: 1,
                  modelValue: formData.value.CompressFile,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.CompressFile) = $event)),
                  class: "task-crop-image-modal__checkbox"
                }, {
                  mainSign: _withCtx(() => [
                    _createTextVNode(" Сжать файл ")
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(TirPmSpinner))
          ]))
    ]),
    footer: _withCtx(() => [
      (formData.value && imageSrc.value && !isLoadingModal.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              "is-disabled": fileNameError.value,
              "is-loading": __props.isLoading,
              onClick: onClickConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(confirmButtonText.value), 1)
              ]),
              _: 1
            }, 8, ["variant", "size", "is-disabled", "is-loading"]),
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).SecondaryState,
              size: _unref(TirPmButtonSizeEnum).Regular,
              onClick: onClose
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Отмена ")
              ]),
              _: 1
            }, 8, ["variant", "size"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible", "title"]))
}
}

})